import axios from 'axios';

export const customAxios = (contentType) => {
    return axios.create({
        responseType: contentType,
        withCredentials: true
    });
}